import { memo } from "react";
import styles from "./machineMarker.module.scss";

interface MachineMarkerProps {
  selected?: boolean;
  disabled?: boolean;
  className?: string;
}

export const MachineMarker = memo(function MachineMarker({
  selected = false,
  disabled = false,
  className
}: MachineMarkerProps) {
  const classes = [
    styles.marker,
    selected && styles.selected,
    disabled && styles.disabled,
    className
  ].filter(Boolean).join(" ");

  return (
    <div
      className={classes}
    >
      <img
        src="/assets/map/printer.webp"
        className={styles.image}
        loading="lazy"
      />
    </div>
  );
});
